export const environment = {
  production: true,
  estado: 'Staging!',
  url_api: 'https://api.staging.gofeels.com/api/v1',
  url_base: 'https://reserva.staging.gofeels.com',
};
